<ng-container *ngIf="textKey === 'COST-COVERAGE_TRAVEL-EXPENSES'" i18n>Reisekosten und Lebenshaltungskosten</ng-container>
